import { APITrackingItem } from './api';

export type APIServerError = {
  error: true;
  payload: {
    status: number;
    body?: {
      Type?: string;
      Title?: string;
    };
  };
};

export enum OrderChangesStatus {
  Pending = 'Pending',
  Approved = 'Approved',
  PartiallyApproved = 'PartiallyApproved',
  Rejected = 'Rejected',
}

export type TrackingItem = APITrackingItem & {
  id?: string;
};

export enum MeasurementUnitSystem {
  Imperial = 'Imperial',
  US = 'US',
  Metric = 'Metric',
}

export type MeasurementUnit = {
  volume: string;
};

export type MeasurementUnitVocabulary = {
  [key in MeasurementUnitSystem]: MeasurementUnit;
};

export const measurementUnitVocabulary: MeasurementUnitVocabulary = {
  [MeasurementUnitSystem.Imperial]: {
    volume: 'CY',
  },
  [MeasurementUnitSystem.US]: {
    volume: 'CY',
  },
  [MeasurementUnitSystem.Metric]: {
    volume: 'M³',
  },
};
